import * as React from 'react';
export const zipSvg = React.forwardRef(function zipSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1A0826',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#AA8FFF',
      d: 'm11.869 12.399.813 6.617h7.953l-.813-6.617h-7.953Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFFFFA',
      d: 'M14.138 9.873c.507.477.576 1.227.155 1.676-.421.448-1.174.425-1.682-.052-.507-.477-.577-1.227-.155-1.675.421-.449 1.174-.426 1.682.051Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFFFFA',
      fillRule: 'evenodd',
      d: 'M28.97 14.781c-.182-1.488-1.351-2.388-2.94-2.382h-5.287l.813 6.617h2.38l-.162-1.323h2.518c1.98 0 2.888-1.235 2.679-2.912Zm-2.936 1.057-2.49.003-.197-1.588 2.503.003c.589.008.89.337.94.792.03.29-.103.79-.756.79Z',
      clipRule: 'evenodd',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFFFFA',
      d: 'm3.586 17.167.227 1.849h7.946l-.262-2.116H7.794l-.034-.264 3.413-2.383-.228-1.854H3l.259 2.118H6.97l.034.264-3.418 2.386Z',
    }),
  );
});
zipSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var zip = {
  category: 'brand',
  colorable: false,
  name: 'zip',
  svg: zipSvg,
};
